import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { ChevronRight, Left } from '../../../components/Icon';
import { Loader } from '../../../components/Loader';
import { PageHeader } from '../../../components/PageHeader';
import { selectWorks } from '../../Api/selectors';
import { exportData, fetchUser } from '../actions';
import { REQUEST_USER } from '../constants';
import { selectUser, selectUsers } from '../selectors';
import { UserDetailsColumns } from './UserDetailsColumns';
import { UserDetailsVars } from './UserDetailsVars';
import { UserDetailsHistory } from './detailsHistory';

const Container = styled.div`
  .content {
    display: inline-block;
    width: 100%;
  }
`;

/* eslint-disable react/prefer-stateless-function */
class UserDetailsComp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  componentDidMount() {
    this.props.fetch();
  }

  get user() {
    return this.props.user;
  }

  render() {
    if (this.props.work || !this.user) return <Loader small />;

    return (
      <Container>
        <PageHeader
          title={
            <div onClick={this.tofn(`/users`)}>
              <Left />
              {this.lbl('users.overview.title')}
            </div>
          }
          breadCrumbs={
            <>
              <a href="/">Vindat</a>
              <ChevronRight />
              {this.lbl('users.overview.title')}
              <ChevronRight />
              {this.user.name}
            </>
          }
        />

        <Switch>
          <Route
            path="(.*)/legacy"
            render={component => <UserDetailsVars key={this.props.user.id} user_id={this.props.user.id} />}
          />
          <Route path="(.*)/history" render={component => <UserDetailsHistory user={this.user} />} />

          <Route render={component => <UserDetailsColumns user={this.user} />} />
        </Switch>
      </Container>
    );
  }
}

UserDetailsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    user: selectUser(ownProps.user_id),
    work: selectWorks([REQUEST_USER]),
    users: selectUsers(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      dispatch(fetchUser(ownProps.user_id));
    },
    fetchUser: (userId, callback) => {
      dispatch(fetchUser(userId, callback));
    },
    exportData: (userId, callback) => {
      dispatch(exportData(userId, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const UserDetails = compose(withConnect, withRouter)(UserDetailsComp);
